module.exports = __webpack_public_path__ + "img/41.98de63db.jpg";